import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchUser, getUserStats} from '../../../../api/UsersAPI';
import AppBreadCrumb from '../../../common/AppBreadCrumb';
import { getAvatar } from '../../../../commonfunctions';

const MemberDetailPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [member, setMember] = useState(null);
    const [stats, setStats] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        Promise.all([
            new Promise(r => fetchUser(id, r)),
            new Promise(r => getUserStats(id, r))
        ]).then(([userRes, statsRes]) => {
            if (userRes.user) setMember(userRes.user);
            // else navigate('/club_portal/members'); // Redirect if user not found
            
            if (statsRes.stats) setStats(statsRes.stats);
            
            setIsLoading(false);
        });
    }, [id, navigate]);

    if (isLoading) return <div className="text-center p-5"><div className="spinner-border"></div></div>;
    if (!member) return <div className="text-center p-5">Member not found.</div>;

    const { batting, bowling, fielding } = stats || {};

    return (
        <main>
            <div className="container-fluid">
                <AppBreadCrumb title="Member Profile" />
                <div className="row">
                    <div className="col-lg-4">
                        <div className="card mb-4">
                            <div className="card-body text-center">
                                <img src={getAvatar(member.profile_pic_path)} alt={member.name} className="rounded-circle img-fluid" style={{ width: '150px' }} />
                                <h5 className="my-3">{member.name}</h5>
                                <p className="text-muted mb-1">Phone: {member.phone_number}</p>
                                <p className="text-muted mb-1">DOB: {member.date_of_birth || 'N/A'}</p>
                                <p className="text-muted mb-4">Blood Group: {member.blood_group || 'N/A'}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="card mb-4">
                            <div className="card-header"><h5>Career Statistics</h5></div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h6>Batting Career</h6>
                                        <ul className="list-group list-group-flush">
                                            <li className="list-group-item d-flex justify-content-between"><span>Innings</span> <strong>{batting?.innings || 0}</strong></li>
                                            <li className="list-group-item d-flex justify-content-between"><span>Total Runs</span> <strong>{batting?.total_runs || 0}</strong></li>
                                            <li className="list-group-item d-flex justify-content-between"><span>Highest Score</span> <strong>{batting?.highest_score || 0}</strong></li>
                                            <li className="list-group-item d-flex justify-content-between"><span>Fours</span> <strong>{batting?.total_fours || 0}</strong></li>
                                            <li className="list-group-item d-flex justify-content-between"><span>Sixes</span> <strong>{batting?.total_sixes || 0}</strong></li>
                                        </ul>
                                    </div>
                                    <div className="col-md-6">
                                        <h6>Bowling & Fielding</h6>
                                        <ul className="list-group list-group-flush">
                                            <li className="list-group-item d-flex justify-content-between"><span>Wickets</span> <strong>{bowling?.total_wickets || 0}</strong></li>
                                            <li className="list-group-item d-flex justify-content-between"><span>Overs Bowled</span> <strong>{bowling?.total_overs_bowled || 0}</strong></li>
                                            <li className="list-group-item d-flex justify-content-between"><span>Maidens</span> <strong>{bowling?.total_maidens || 0}</strong></li>
                                            <li className="list-group-item d-flex justify-content-between"><span>Catches</span> <strong>{fielding?.catches || 0}</strong></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default MemberDetailPage;
